import { PieChart } from '@charts';
import { colors } from '@common/helpers';
import { FC } from 'react';
import { DiseasesChartCardProps } from './DiseasesChartCard.types';

import { ChartReferences } from '@builder/organisms/Charts/ChartReferences';
import { InfoCard } from '@builder';
import {
  StyledChartContainer,
  StyledNoDataMessage,
  StyledReferencesContainer,
  chartReferencesColumnStyles,
  chartReferencesLabelStyles,
  infoCardStyles,
} from './DiseasesChartCard.styles';

const PINK = [colors.pink200, colors.pink500, colors.pink700];

const DiseasesChartCard: FC<DiseasesChartCardProps> = ({ data, isDataAvailable, noDataAvailableMessage }) => {
  return (
    <InfoCard css={infoCardStyles} hasBorder>
      <StyledReferencesContainer>
        <ChartReferences
          data={data}
          columnStyles={chartReferencesColumnStyles}
          labelStyles={chartReferencesLabelStyles}
          referencesColors={PINK}
          showPercentage={false}
        />
      </StyledReferencesContainer>

      <StyledChartContainer>
        {isDataAvailable ? (
          <PieChart data={data} chartColors={PINK} showLabel={false} />
        ) : (
          <StyledNoDataMessage>{noDataAvailableMessage}</StyledNoDataMessage>
        )}
      </StyledChartContainer>
    </InfoCard>
  );
};

export default DiseasesChartCard;
